export const BrandListConstants = {
    GET_BRANDS_LIST: 'GET_BRANDS_LIST',

    GETALL_BRANDS_REQUEST: 'GETALL_BRANDS_REQUEST',
    GETALL_BRANDS_SUCCESS: 'GETALL_BRANDS_SUCCESS',
    GETALL_BRANDS_FAILURE: 'GETALL_BRANDS_FAILURE'
};
